import React, {useEffect, useState} from 'react';
import type {UniqueIdentifier} from '@dnd-kit/core';
import { observer } from 'mobx-react-lite';
import 'react-loading-skeleton/dist/skeleton.css';
import {ItemProps} from '../../../../entity/props/document/item-props';
import {useService} from '../../../../infrastructure/service/service';
import AccordionDocument from './AccordionDocument';
import {Document} from '../../../../entity/resource/document';
import {Section} from '../../../../entity/resource/section';
import {isValidExtension} from '../../../../shared/document/validator';

import '../../../../assets/css/style.css';
import '../../../../assets/css/document/accordion-document.css';

export const Item = observer(React.forwardRef<HTMLLIElement, ItemProps>((props: ItemProps, ref: React.ForwardedRef<HTMLLIElement>): JSX.Element => {
  const {projectService, titleService, titleTemplateService} = useService();

  const [actionDenied, setActionDenied] = useState<boolean>(false);

  useEffect(() => {
    if (!props.dragOverlay)
      return;
    document.body.style.cursor = 'grabbing';

    return () => {document.body.style.cursor = ''}
  }, [props.dragOverlay]);

  useEffect(() => {
    const title = titleService.getTitle();
    setActionDenied(title ? !projectService.isPermittedTitle(title.id) : false);
  }, []);

  const findDocumentById = (id: UniqueIdentifier): Document | undefined => {
    const sections = props.project ? titleService.getTitle()?.sections ?? [] : titleTemplateService.getTitleTemplate()?.sections ?? [];
    return sections.flatMap((section: Section): Document[] => section.documents).find((document: Document): boolean => document.id === id);
  }

  const handleSelect = (): void => {
    const document = findDocumentById(props.documentId);
    if (!isValidExtension(document?.name))
      return;

    if (!actionDenied && props.onSelect)
      props.onSelect()
  }

  return <li ref={ref} className={props.parentClassName} style={props.parentStyle}>
    <div className={props.itemClassName}
      style={props.itemStyle}
      data-cypress='draggable-item'
      {...(!props.handle ? props.listeners : undefined)}
      tabIndex={!props.handle ? 0 : undefined}
      onClick={handleSelect}>
      <AccordionDocument
        key={'d' + props.value}
        data-accid={props.value}
        project={props.project}
        selected={props.selected}
        document={findDocumentById(props.value as UniqueIdentifier)}
        titleId={titleService.getTitle()?.id ?? ''}
        sections={props.project ? titleService.getTitle()?.sections ?? [] : titleTemplateService.getTitleTemplate()?.sections ?? []}
        handle={props.handle}
        handleProps={props.handleProps}
        listeners={props.listeners}
        actionDenied={actionDenied}
        items={props.items}
        setItems={props.setItems}/>
    </div>
  </li>
}));
